import { render, staticRenderFns } from "./ExpensesRowItem.vue?vue&type=template&id=397605de&scoped=true&lang=pug&"
import script from "./ExpensesRowItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpensesRowItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpensesRowItem.vue?vue&type=style&index=0&id=397605de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397605de",
  null
  
)

export default component.exports